import React    from "react"
import Combobox from "@shared/combobox" 

export const DefaultStorehouse = ({ storehouses, workorderState, setWorkorderState }) => {
  const selectStorehouse = storehouse => {
    setWorkorderState({ ... workorderState, defaultStorehouseKey: storehouse.id || null })
  }

  return (
    <div className='form-group'>
      <label>
        { I18n.t("workorders.default_storehouse") }
      </label>

      <Combobox
        prompt          = { I18n.t("workorders.default_storehouse_prompt") }
        options         = { storehouses }
        onSelectElement = { selectStorehouse }
        value           = { workorderState.defaultStorehouseKey }
      />
    </div>
  )
}